(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsWeekSchemeTypeController', ['$stateParams', 'weekschemes', AgendaSettingsWeekSchemeTypeControllerFn]);

    /* controlle for main week schemes */
    function AgendaSettingsWeekSchemeTypeControllerFn($stateParams, weekschemes) {
        var vm = this;

        // weekschemes
        vm.weekschemes = [];
        vm.individual = false;
        vm.label = '';

        activate();

        /* activation work */
        function activate() {
            vm.weekschemes = weekschemes;
            vm.individual = $stateParams.individual;
            if ($stateParams.individual) {
                vm.label = 'individual';
            }//if
            else {
                vm.label = 'alternately';
            } //else

            // clear
            weekschemes = null;

        } // activate
    }
})();
